export default function AnalyticsPage() {
  return <div style={{ padding: 30 }}><h1>Analytics</h1><p>Coming soon...</p></div>;
}
